import removeAccents from 'remove-accents';

export const userContains = (user, filter) => {
  const f = removeAccents(filter).toLowerCase();
  return removeAccents(getUserName(user)).toLowerCase().includes(f);
};

export const getUserPhytoNumber = (user, clusterId) => {
  if (!user || !user.cluster_roles) {
    return null;
  }
  const cluster_role = user.cluster_roles.find(({ cluster_id }) => {
    return cluster_id === clusterId;
  });
  return cluster_role?.certiphyto_number;
};

export const getUserName = (user) => {
  if (!user) return '';
  // worksites and device sessions carry the user flattened as `user_fullname` / `user_email`
  const name = (user.fullname ?? user.user_fullname ?? '').trim();
  return name || user.email || user.email_address || user.user_email || '';
};

export const sortUserByBeaconLinked = (a, b) =>
  a.current_beacon_uuid && !b.current_beacon_uuid ? -1 : b.current_beacon_uuid && !a.current_beacon_uuid ? 1 : 0;

export function sortByCertiphytoFirst(a, b, clusterId) {
  if (getUserPhytoNumber(a, clusterId) && !getUserPhytoNumber(b, clusterId)) return -1;
  if (!getUserPhytoNumber(a, clusterId) && getUserPhytoNumber(b, clusterId)) return 1;
  return 0;
}

export function getUserClusterPhoneNumber(user, clusterId) {
  if (!user || !user.cluster_roles) {
    return null;
  }
  const cluster_role = user.cluster_roles.find(({ cluster_id }) => {
    return cluster_id === clusterId;
  });
  return cluster_role?.phonenumber;
}

export function getUserPhoneNumberToDisplay(user, clusterId) {
  if (!user) {
    return null;
  }
  return getUserClusterPhoneNumber(user, clusterId) || user.phonenumber;
}
